export default {
  jp: {
    title: {
      availableServices: '利用可能サービス',
      changeAccountInfo: '登録情報変更',
      manual: 'マニュアル',
      subMenuGroupAdmin: 'グループ責任者向けメニュー',
      manageAccount: 'アカウント管理',
      acceptAccountEntry: 'アカウント申請受付',
      subMenuAdmin: '管理者向けメニュー',
      manageAccountAdmin: 'アカウント管理',
      accountChangeGroup: 'アカウント所属変更',
      acceptAccountEntryAdmin: 'アカウント申請受付',
      acceptAccountServiceApplicationAdmin: '利用サービス申請受付',
      manageGroups: 'グループ管理',
      manageCompany: '会社管理',
      manageServices: 'サービス管理',
      sendMail: 'メール一斉配信'
    },
    label: {
    },
    ph: {
    },
    button: {
    },
    desc: {
    }
  },
  en: {
    title: {
      availableServices: 'Services',
      changeAccountInfo: 'Change Information',
      manual: 'Manual',
      subMenuGroupAdmin: 'Menu for Group Managers',
      manageAccount: 'Account Management',
      acceptAccountEntry: 'Accepting Applications',
      subMenuAdmin: 'Menu for Administrators',
      manageAccountAdmin: 'Account Management',
      accountChangeGroup: 'Change Account Group',
      acceptAccountEntryAdmin: 'Accepting Applications',
      acceptAccountServiceApplicationAdmin: 'Accepting Service Applications',
      manageGroups: 'group Management',
      manageCompany: 'Company Management',
      manageServices: 'service Management',
      sendMail: 'mail Delivery'
    },
    label: {
    },
    ph: {
    },
    button: {
    },
    desc: {
    }
  }

}
